import { CONSTANTS } from '../constants/constants';

// Overall status of a ticket derived from its task list: nothing completed ->
// not started, everything completed -> completed, anything in between -> in progress.
export const summarizeTasksStatus = (tasks) => {
  if (!Array.isArray(tasks) || tasks.length === 0) {
    return CONSTANTS.STATUS.NOT_STARTED;
  }

  const completedCount = tasks.filter((task) => task.completed).length;

  if (completedCount === 0) return CONSTANTS.STATUS.NOT_STARTED;
  if (completedCount === tasks.length) return CONSTANTS.STATUS.COMPLETED;
  return CONSTANTS.STATUS.IN_PROGRESS;
};
